import React, {useState} from 'react';
import {
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
} from '@material-ui/core';

export default ({
    escolhaData,
    handlerChangeRadioEscolhaData
}) => {
    const [escolhaDataView, setEscolhaDataView] = useState(escolhaData);

    const handleChangeEscolhaDataView = (event) => {
        setEscolhaDataView(event.target.value);
        handlerChangeRadioEscolhaData(event.target.value);
    };
    return (
        <FormControl component="fieldset">
            <RadioGroup
                aria-label="data"
                name="data1"
                value={escolhaDataView}
                onChange={handleChangeEscolhaDataView}
            >
                <FormControlLabel
                    value={"dtEmissao"}
                    control={<Radio/>}
                    label="Data de emissão"
                />
                <FormControlLabel
                    value={"dtAgendamento"}
                    control={<Radio/>}
                    label="Data de agendamento"
                />
            </RadioGroup>
        </FormControl>
    );
};